import { render } from "./index.vue?vue&type=template&id=8f09a468"
import script from "./pagination.ts?vue&type=script&lang=js"
export * from "./pagination.ts?vue&type=script&lang=js"

import "./pagination.scss?vue&type=style&index=0&lang=scss"
script.render = render

export default script